import React from 'react'
import * as yup from 'yup'
import { Formik, Field } from 'formik'
import TextField from '@material-ui/core/TextField'
import { zipValidation } from 'components/forms/validations'
const zipInput = props => {
  return (
    <TextField
      error={props.error && props.form.isSubmitting && true}
      helperText={
        props.error && props.touched && props.error === ' '
          ? 'This field is required.'
          : props.error
      }
      label={props.label}
      type={props.type}
      defaultValue={props.defaultValue}
      variant="filled"
      name={props.name}
      onChange={e => props.form.setFieldValue(props.field.name, e.target.value)}
    />
  )
}

const LocatorForm = ({ onZipCodeChanged }) => {
  const validateZip = yup.object().shape({
    zip: zipValidation,
  })
  return (
    <div className="locator--form-container">
      <Formik
        validationSchema={validateZip}
        validateOnBlur={false}
        validateOnChange={false}
        initialValues={{ zip: '' }}
        onSubmit={values => {
          onZipCodeChanged(values.zip)
        }}
      >
        {({ errors, handleSubmit, initialValues }) => {
          return (
            <form onSubmit={handleSubmit} className={`locator--form`}>
              <div className="left">
                <div className="input-wrapper">
                  <Field
                    name="zip"
                    type="number"
                    label="Enter your ZIP code"
                    error={errors.zip}
                    component={zipInput}
                    variant="filled"
                  />
                </div>
              </div>
              <div className="right">
                <input
                  className="btn"
                  type="submit"
                  value="Find stores near me"
                />
              </div>
            </form>
          )
        }}
      </Formik>
    </div>
  )
}
export default LocatorForm
